<div *ngIf="data.length === 0">

    <img class="gif" src="/assets/gif/jenny3.gif" />
</div>